import { useState } from 'react';

import { useOperationTraders } from 'api/requests/operation';
import { SelectFilter } from 'components';
import { useTranslation } from 'libs/i18n';

interface TradersFilterFeatureProps {
  selectedTraders: string[];
  setSelectedTraders: (traders: string[]) => void;
}

export const TradersFilterFeature = ({
  selectedTraders,
  setSelectedTraders,
}: TradersFilterFeatureProps) => {
  const { t } = useTranslation();

  const [search, setSearch] = useState('');

  const { listData, loading } = useOperationTraders({
    pagination: { limit: 20, page: 0 },
    filter: {
      search,
    },
    params: undefined,
  });

  const onChange = (activeValues: string[]) => {
    setSelectedTraders(activeValues);
  };

  return (
    <SelectFilter
      enabledSearch
      activeValues={selectedTraders}
      loading={loading}
      options={(listData?.list ?? []).map((trader) => ({
        label: trader.name,
        value: trader.id,
      }))}
      search={search}
      title={t('operation.filters.trader')}
      onChange={onChange}
      onSearchChange={setSearch}
    />
  );
};
